import { render, staticRenderFns } from "./update_pwd.vue?vue&type=template&id=0cae0c4c&scoped=true&"
import script from "./update_pwd.vue?vue&type=script&lang=js&"
export * from "./update_pwd.vue?vue&type=script&lang=js&"
import style0 from "./register.css?vue&type=style&index=0&id=0cae0c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae0c4c",
  null
  
)

export default component.exports